import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row mb-2" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row mt-2" }
const _hoisted_4 = {
  for: "enabled",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_5 = { class: "col-sm-8" }
const _hoisted_6 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_7 = { class: "row mt-2" }
const _hoisted_8 = {
  for: "beforeTraderRequisites",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_9 = { class: "col-sm-8" }
const _hoisted_10 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_11 = { class: "row mt-2" }
const _hoisted_12 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_13 = { class: "col-sm-8" }
const _hoisted_14 = { class: "row mt-2" }
const _hoisted_15 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_16 = { class: "col-sm-8" }
const _hoisted_17 = { class: "row mt-2" }
const _hoisted_18 = {
  for: "currency",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_19 = { class: "col-sm-8" }
const _hoisted_20 = { class: "row mt-2" }
const _hoisted_21 = {
  for: "minAmount",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_22 = { class: "col-sm-8" }
const _hoisted_23 = { class: "row mt-2" }
const _hoisted_24 = {
  for: "maxAmount",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_25 = { class: "col-sm-8" }
const _hoisted_26 = { class: "row mt-2" }
const _hoisted_27 = {
  for: "paymentOptions",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_28 = { class: "col-sm-8" }
const _hoisted_29 = { class: "row mt-2" }
const _hoisted_30 = {
  for: "paymentMethods",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_31 = { class: "col-sm-8" }
const _hoisted_32 = { class: "d-flex flex-row align-items-center gap-2" }
const _hoisted_33 = {
  class: "overflow-hidden",
  style: {"white-space":"nowrap","text-overflow":"ellipsis"}
}
const _hoisted_34 = { class: "row mt-2" }
const _hoisted_35 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_36 = { class: "col-sm-8" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = { class: "row mt-2" }
const _hoisted_39 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_40 = { class: "col-sm-8" }
const _hoisted_41 = {
  key: 0,
  class: "text-muted d-block mb-2"
}
const _hoisted_42 = { class: "text-muted d-block mt-2" }
const _hoisted_43 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_44 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_45 = { class: "col-sm-8" }
const _hoisted_46 = {
  key: 1,
  class: "row mt-2"
}
const _hoisted_47 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_48 = { class: "col-sm-8" }
const _hoisted_49 = {
  key: 2,
  class: "row mt-2"
}
const _hoisted_50 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_51 = { class: "col-sm-8" }
const _hoisted_52 = { class: "row mt-2" }
const _hoisted_53 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_54 = { class: "row mt-2" }
const _hoisted_55 = { class: "" }
const _hoisted_56 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative" }
const _hoisted_57 = { class: "text-capitalize" }
const _hoisted_58 = { class: "text-capitalize" }
const _hoisted_59 = { class: "draggable" }
const _hoisted_60 = {
  style: {"width":"0"},
  class: "p-0 position-relative"
}
const _hoisted_61 = { class: "d-flex flex-row" }
const _hoisted_62 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_63 = ["onClick"]
const _hoisted_64 = { style: {"width":"0"} }
const _hoisted_65 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_66 = ["onUpdate:modelValue"]
const _hoisted_67 = { class: "position-relative" }
const _hoisted_68 = {
  class: "text-end",
  style: {"width":"0"}
}
const _hoisted_69 = ["onClick"]
const _hoisted_70 = { colspan: "4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_PayMethodIcon = _resolveComponent("PayMethodIcon")!
  const _component_StoreMultiselect = _resolveComponent("StoreMultiselect")!
  const _component_Sortable = _resolveComponent("Sortable")!

  return (_openBlock(), _createElementBlock("form", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.helper.trans("labels.enabled")), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.enabled) = $event)),
                class: "form-check-input",
                type: "checkbox",
                id: "enabled"
              }, null, 512), [
                [_vModelCheckbox, _ctx.form.enabled]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.helper.trans("labels.cascadeBeforeTraderRequisites")), 1),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.beforeTraderRequisites) = $event)),
                class: "form-check-input",
                type: "checkbox",
                id: "beforeTraderRequisites"
              }, null, 512), [
                [_vModelCheckbox, _ctx.form.beforeTraderRequisites]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.helper.trans("labels.name")) + ":", 1),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(`name`)
            }, {
              default: _withCtx((parentProps) => [
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass([parentProps.class, "form-control"]),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.name) = $event)),
                  type: "text",
                  id: "name"
                }, null, 2), [
                  [_vModelText, _ctx.form.name]
                ])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.helper.trans("labels.type")) + ":", 1),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(`type`)
            }, {
              default: _withCtx((parentProps) => [
                _createVNode(_component_Multiselect, {
                  class: _normalizeClass(parentProps.class),
                  modelValue: _ctx.form.direction,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.direction) = $event)),
                  options: [_ctx.Direction.PAY_IN, _ctx.Direction.PAY_OUT],
                  "custom-label": (opt) => _ctx.helper.trans(`direction.${opt}`),
                  multiple: false,
                  "select-label": "Select",
                  placeholder: ""
                }, null, 8, ["class", "modelValue", "options", "custom-label"])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.helper.trans("labels.currency")), 1),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_FormInputWrapper, {
              field: "currency",
              form: "requisitesForm"
            }, {
              default: _withCtx((parentProps) => [
                _createVNode(_component_Multiselect, {
                  id: "currency",
                  class: _normalizeClass(["", parentProps.class]),
                  modelValue: _ctx.form.currency,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.currency) = $event)),
                  options: _ctx.store.getters['currencyMethods/currencies'],
                  "custom-label": (opt) => `${opt}`,
                  multiple: false,
                  "select-label": "Select",
                  placeholder: ""
                }, null, 8, ["modelValue", "options", "custom-label", "class"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.helper.trans("labels.from_sum")), 1),
          _createElementVNode("div", _hoisted_22, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.minAmount) = $event))
            }, null, 512), [
              [_vModelText, _ctx.form.minAmount]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.helper.trans("labels.to_sum")), 1),
          _createElementVNode("div", _hoisted_25, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.maxAmount) = $event))
            }, null, 512), [
              [_vModelText, _ctx.form.maxAmount]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.helper.trans("labels.payment_options")), 1),
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_Multiselect, {
              id: "paymentOptions",
              modelValue: _ctx.form.paymentOptions,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.paymentOptions) = $event)),
              options: _ctx.store.getters['currencyMethods/options'](),
              "custom-label": (opt) => _ctx.helper.trans(`payment_options.${opt}`),
              multiple: true,
              "select-label": "Select",
              placeholder: _ctx.helper.trans('labels.payment_options')
            }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.helper.trans("labels.payment_methods")), 1),
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_component_Multiselect, {
              id: "paymentMethods",
              modelValue: _ctx.form.paymentMethods,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.paymentMethods) = $event)),
              options: _ctx.store.getters['currencyMethods/methods'](),
              "custom-label": (opt) => _ctx.helper.trans(`pay_methods.${opt}`),
              multiple: true,
              "select-label": "Select",
              placeholder: _ctx.helper.trans('labels.payment_methods')
            }, {
              option: _withCtx((props) => [
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_PayMethodIcon, {
                    "icon-class": "icon",
                    method: props.option
                  }, null, 8, ["method"]),
                  _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.helper.trans('pay_methods.' + props.option)), 1)
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "options", "custom-label", "placeholder"])
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.helper.trans("labels.stores")) + ":", 1),
          _createElementVNode("div", _hoisted_36, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(`storeIds`)
            }, {
              default: _withCtx((parentProps) => [
                _createVNode(_component_StoreMultiselect, {
                  class: _normalizeClass(parentProps.class),
                  small: false,
                  modelValue: _ctx.form.stores,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.stores) = $event)),
                  multiple: true
                }, null, 8, ["class", "modelValue"])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        (_ctx.providerRatingEnabled)
          ? (_openBlock(), _createElementBlock("fieldset", {
              key: 0,
              disabled: _ctx.form.isAsync,
              class: "mt-2"
            }, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.helper.trans("labels.provider_rating")), 1),
                _createElementVNode("div", _hoisted_40, [
                  (_ctx.form.isAsync)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_41, _toDisplayString(_ctx.helper.trans("labels.provider_rating_sync_only")), 1))
                    : _createCommentVNode("", true),
                  _createVNode(_component_Multiselect, {
                    "model-value": _ctx.selectedRatingTypeOption,
                    "onUpdate:modelValue": _ctx.onRatingTypeSelect,
                    options: _ctx.ratingTypeSelectOptions,
                    "custom-label": _ctx.ratingTypeOptionLabel,
                    "track-by": "value",
                    multiple: false,
                    "allow-empty": false,
                    "select-label": "Select",
                    placeholder: ""
                  }, null, 8, ["model-value", "onUpdate:modelValue", "options", "custom-label"]),
                  _createElementVNode("small", _hoisted_42, _toDisplayString(_ctx.helper.trans("labels.provider_rating_manual_order_hint")), 1)
                ])
              ]),
              (_ctx.form.ratingType === 'mix_conversion')
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.helper.trans("labels.provider_rating_coefficient_a")), 1),
                    _createElementVNode("div", _hoisted_45, [
                      _createVNode(_component_FormInputWrapper, {
                        errors: _ctx.getErrors('ratingA')
                      }, {
                        default: _withCtx((parentProps) => [
                          _withDirectives(_createElementVNode("input", {
                            class: _normalizeClass([parentProps.class, "form-control"]),
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.ratingA) = $event)),
                            type: "text"
                          }, null, 2), [
                            [_vModelText, _ctx.form.ratingA]
                          ])
                        ]),
                        _: 1
                      }, 8, ["errors"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.form.ratingType === 'mix_conversion')
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.helper.trans("labels.provider_rating_coefficient_b")), 1),
                    _createElementVNode("div", _hoisted_48, [
                      _createVNode(_component_FormInputWrapper, {
                        errors: _ctx.getErrors('ratingB')
                      }, {
                        default: _withCtx((parentProps) => [
                          _withDirectives(_createElementVNode("input", {
                            class: _normalizeClass([parentProps.class, "form-control"]),
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.ratingB) = $event)),
                            type: "text"
                          }, null, 2), [
                            [_vModelText, _ctx.form.ratingB]
                          ])
                        ]),
                        _: 1
                      }, 8, ["errors"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.form.ratingType === 'mix_conversion')
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                    _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.helper.trans("labels.provider_rating_coefficient_c")), 1),
                    _createElementVNode("div", _hoisted_51, [
                      _createVNode(_component_FormInputWrapper, {
                        errors: _ctx.getErrors('ratingC')
                      }, {
                        default: _withCtx((parentProps) => [
                          _withDirectives(_createElementVNode("input", {
                            class: _normalizeClass([parentProps.class, "form-control"]),
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.ratingC) = $event)),
                            type: "text"
                          }, null, 2), [
                            [_vModelText, _ctx.form.ratingC]
                          ])
                        ]),
                        _: 1
                      }, 8, ["errors"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 8, _hoisted_37))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.helper.trans("labels.providers")), 1)
        ]),
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("table", _hoisted_56, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _cache[15] || (_cache[15] = _createElementVNode("th", null, null, -1)),
                  _createElementVNode("th", _hoisted_57, _toDisplayString(_ctx.helper.trans('labels.is_active')), 1),
                  _createElementVNode("th", _hoisted_58, _toDisplayString(_ctx.helper.trans('labels.name')), 1),
                  _cache[16] || (_cache[16] = _createElementVNode("th", null, null, -1))
                ])
              ]),
              _createVNode(_component_Sortable, {
                list: _ctx.form.providers,
                "item-key": "id",
                onEnd: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onUpdate($event))),
                tag: "tbody",
                class: "",
                options: {draggable: '.draggable', handle: '.drag-handle'}
              }, {
                item: _withCtx(({element, index}) => [
                  _createElementVNode("tr", _hoisted_59, [
                    _createElementVNode("td", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("div", _hoisted_62, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["ms-3 badge", _ctx.getBadgeBackground(_ctx.form.providers[index].priority)])
                          }, _toDisplayString(_ctx.form.providers[index].priority), 3)
                        ]),
                        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "drag-handle p-2 ps-4 pe-4 m-2" }, [
                          _createElementVNode("i", { class: "fa-solid fa-grip-vertical" })
                        ], -1))
                      ]),
                      (_ctx.form.providers[index + 1])
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: "#",
                            class: _normalizeClass(["link-provider", {linked: _ctx.isProviderLinked(index, index + 1)}]),
                            onClick: _withModifiers(($event: any) => (_ctx.linkProviders(index, index + 1)), ["prevent"])
                          }, _cache[18] || (_cache[18] = [
                            _createElementVNode("i", { class: "fa-solid fa-link p-2" }, null, -1)
                          ]), 10, _hoisted_63))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_64, [
                      _createElementVNode("div", _hoisted_65, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((_ctx.form.providers[index].enabled) = $event),
                          class: "form-check-input",
                          type: "checkbox",
                          id: "enabled"
                        }, null, 8, _hoisted_66), [
                          [_vModelCheckbox, _ctx.form.providers[index].enabled]
                        ])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_67, [
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.form.providers[index].providerId,
                        "onUpdate:modelValue": ($event: any) => ((_ctx.form.providers[index].providerId) = $event),
                        class: "multiselect-sm",
                        options: Object.keys(_ctx.providers),
                        "custom-label": (opt) => _ctx.providers[opt]._trader?.name,
                        multiple: false,
                        "select-label": "Select"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "custom-label"])
                    ]),
                    _createElementVNode("td", _hoisted_68, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _withModifiers(($event: any) => (_ctx.deleteProvider(index)), ["prevent"]),
                        class: "btn btn-sm btn-outline-danger"
                      }, _cache[19] || (_cache[19] = [
                        _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                      ]), 8, _hoisted_69)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["list"]),
              _createElementVNode("tfoot", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_70, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.addProvider()), ["prevent"])),
                      class: "btn btn-sm w-100 btn-outline-primary"
                    }, _toDisplayString(_ctx.helper.trans('button.add')), 1)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}